import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { IFile } from '@repo/toolkit/types'

import { LinkTwoIcon } from '../../icons'

type Props = {
  file: IFile
  label?: string
}

const LinkFile = ({ file, label = 'Pièce jointe' }: Props) => {
  return (
    <div className="flex items-center ">
      <LinkTwoIcon color={tailwindColors.primary.DEFAULT} />
      <a
        href={file.path}
        target="_blank"
        rel="noreferrer"
        onClick={(e) => e.stopPropagation()}
        className="text-primary font-medium text-xs underline"
      >
        {label}
      </a>
    </div>
  )
}

export default LinkFile
